export default __webpack_public_path__ + "static/media/725941f0132cc713.e6a0dfaad73aea747acfdd6e900454da.svg";